import _ from 'lodash';
import { IPartyPreview } from '../../Party';
import { TPartyKey } from '../../PartyClientResponse';

const PRIORITIZED_PARTY_SLUGS = [
  'insomniac',
  'monstercat',
  'hotbeatstv',
  'ellipticalsun',
  'lionastone',
];

const getSortedPartyList = (
  partyPreviews: Record<string, IPartyPreview>,
  partyKey?: TPartyKey
): IPartyPreview[] => {
  return (
    _.chain(partyPreviews || {})
      .values()
      .filter((p) => Object.values(p?.participants || {}).length > 2)
      .sortBy((pp) => Object.values(pp?.participants || {}).length)
      .reverse()
      .concat(
        Object.values(partyPreviews || {}).filter((p) => PRIORITIZED_PARTY_SLUGS.includes(p.slug))
      )
      // .concat(Object.values(partyPreviews || {}).filter((p) => p.active))
      .uniqBy((p) => p.key)
      .filter((p) => p.key !== partyKey)
      .slice(0, 10)
      .value()
  );
};

export default getSortedPartyList;
